import { createFileRoute } from '@tanstack/react-router';
import { RelatorioVendaRelacaoVendasProduto } from '@/features/relatorio/page/venda/relacao-vendas-produto/RelatorioVendaRelacaoVendasProduto';

export const Route = createFileRoute('/a/relatorio/venda/relacao-vendas-produto')({
    component: RelatorioVendaRelacaoVendasProduto,
});
